import {
  ENTITY_REFERENCE_TYPE_LABEL,
  ENTITY_REFERENCE_TYPE_ORDER,
  getEntityReferenceKey,
} from '../TeamChat.entityReferences.utils';

export const buildReferenceGroups = index =>
  ENTITY_REFERENCE_TYPE_ORDER.reduce((groups, entityType) => {
    const items = Object.values(index[entityType] ?? {}).sort(
      (a, b) => b.count - a.count || a.label.localeCompare(b.label),
    );

    if (items.length) {
      groups.push({ type: entityType, label: ENTITY_REFERENCE_TYPE_LABEL[entityType], items });
    }

    return groups;
  }, []);

export const getTotalReferenceItemCount = groups =>
  groups.reduce((total, group) => total + group.items.length, 0);

// Distinct-items count, not message count (each item pill separately shows its own message
// count) — the unit needs to be explicit so the header number isn't misread as a message tally.
export const getReferenceCountLabel = count => `${count} item${count === 1 ? '' : 's'}`;

// The client-side index only covers the loaded message page (TEAM_CHAT_MESSAGES_PAGE_SIZE), not
// the channel's full history — the header count is an approximation until the server aggregate
// (DEV-5447's `GET entity-references`, exposed client-side as the already-built but unused
// `chatsApi.getMessagesBySubjectPath`) replaces this client-built tally.
export const REFERENCE_COUNT_QUALIFIER = 'Counts reflect recent messages only';

export const findReferenceItemByKey = (groups, activeKey) => {
  if (!activeKey) {
    return null;
  }

  return (
    groups.flatMap(group => group.items).find(item => getEntityReferenceKey(item) === activeKey) ??
    null
  );
};
